export function blogFilter() {
    const buttons = document.querySelectorAll(".filter-button");
    const postsContainer = document.querySelector("#blog-posts");
    const loadMoreButton = document.querySelector("#load-more-posts");

    if (!buttons.length || !postsContainer || !loadMoreButton) return;

    let currentCategory = "all";
    let currentPage = 1;
    const postsPerPage = 8;

    function fetchPosts(reset = false) {
		const formData = new URLSearchParams();
		formData.append("action", "filter_blog_posts");
		formData.append("category", currentCategory);
		formData.append("page", currentPage);
		formData.append("ppp", postsPerPage);

      fetch("/wp-admin/admin-ajax.php", {
			method: "POST",
			headers: { "Content-Type": "application/x-www-form-urlencoded" },
			body: formData
      })
      .then(response => response.json())
      .then(data => {
			if (reset) {
			postsContainer.innerHTML = data.html;
			currentPage = 1;
			} else {
			postsContainer.insertAdjacentHTML("beforeend", data.html);
			}

        const newCards = postsContainer.querySelectorAll(".article-card:not(.animate-in)");
        newCards.forEach((card, index) => {
			setTimeout(() => {
				card.classList.add("animate-in");
			}, 40 * index);
        });

        loadMoreButton.style.display = data.has_more ? "block" : "none";
      });
    }

    buttons.forEach((button) => {
		button.addEventListener("click", function (e) {
			e.preventDefault();
			buttons.forEach(btn => btn.classList.remove("filter-button--active"));
			button.classList.add("filter-button--active");

			currentCategory = button.getAttribute("data-category");
			currentPage = 1;

			postsContainer.style.opacity = 0.4;
			fetchPosts(true);
			postsContainer.style.opacity = 1;
		});
    });

    loadMoreButton.addEventListener("click", function () {
		currentPage++;
		fetchPosts();
    });

    fetchPosts(true);
}